"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSureSuccessExperience() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="86918" id="our-magic-world" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden relative" ref={sectionRef}>
      {}
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-secondary/20 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-12 items-center">
          
          {}
          <div className="lg:col-span-7 relative h-[500px] sm:h-[600px] w-full">
            {}
            <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95 translate-y-8"}`}>
              <div className="w-full h-full rounded-[3rem] overflow-hidden shadow-2xl shadow-primary/20 border-4 border-white">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614297/img/sure_success_campus_main.png" alt="LinguaKids magical learning environment" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
            </div>

            {}
            <div className={`absolute top-0 right-0 w-[45%] h-[45%] z-20 transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0 translate-x-0" : "opacity-0 -translate-y-12 translate-x-12"}`}>
              <div className="w-full h-full rounded-full overflow-hidden shadow-xl shadow-secondary/30 border-8 border-background">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614297/img/sure_success_students_learning.png" alt="Happy child learning Spanish" className="w-full h-full object-cover hover:scale-110 transition-transform duration-700" />
              </div>
            </div>

            {}
            <div className={`absolute bottom-4 left-0 w-[50%] h-[40%] z-30 transition-all duration-1000 delay-400 ease-out ${isVisible ? "opacity-100 translate-y-0 -translate-x-0" : "opacity-0 translate-y-12 -translate-x-12"}`}>
              <div className="w-full h-full rounded-tl-[4rem] rounded-br-[4rem] rounded-tr-2xl rounded-bl-2xl overflow-hidden shadow-xl shadow-accent/20 border-8 border-background">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614297/img/sure_success_activities.png" alt="Fun Spanish games and activities" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
            </div>
          </div>

          {}
          <div className={`lg:col-span-5 flex flex-col justify-center transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/20 text-accent-foreground text-sm font-bold mb-6 w-fit border-2 border-accent/30 shadow-sm">
              <span className="size-3 rounded-full bg-accent animate-pulse" />
              ¡Hola! Welcome to LinguaKids
            </div>
            
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-foreground mb-6 leading-tight">
              Where Learning <br className="hidden lg:block" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
                Spanish Feels
              </span>
              <br className="hidden lg:block" /> Like Play
            </h2>
            
            <p className="text-xl font-sans text-muted-foreground leading-relaxed mb-8">
              At LinguaKids, children learn Spanish in a way that feels exciting, natural, and joyful. Our live online lessons are designed to keep kids engaged, smiling, and speaking from day one through magical adventures.
            </p>
            
            <div className="flex flex-wrap items-center gap-4">
              <Button asChild size="lg" className="group rounded-full px-10 h-16 text-lg font-bold bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg shadow-primary/30 transition-all hover:scale-105 active:scale-95">
                <Link to="/OurClassesPage">
                  Explore Classes
                  <ArrowRight className="ml-2 size-6 transition-transform duration-300 group-hover:translate-x-2" />
                </Link>
              </Button>
              
              <div className="flex items-center gap-4 ml-2">
                <div className="flex -space-x-4">
                  {[1, 2, 3].map(i => <div key={i} data-index={i} className="size-12 rounded-full border-4 border-background overflow-hidden bg-muted shadow-md">
                      <img src={`/img/student_avatar_${i}.png`} alt={`Little Explorer ${i}`} className="w-full h-full object-cover" />
                    </div>)}
                </div>
                <div className="text-base text-muted-foreground font-bold">
                  Join <span className="text-secondary">500+</span> <br /> Little Explorers
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}